
export const StyleMode ={
    desktop:`DESKTOP`,
    tablet:`TABLET`,
    mobile:`MOBILE`
}

export const CheckIsEnable=(is_enable:string)=>{
    return is_enable===`Yes`
}


export const VideoPages={
    hadracha:'hadrachacenter',
    shetach:'shetachunit',
    mate:'mateemployee',
    candidate:'newcandidate'
}

export const VideoPagesIndex={
    'hadrachacenter':1,
    'shetachunit':2,
    'mateemployee':3,
    'newcandidate':0
}
